import React from 'react';

/**
 * Get authentication token from localStorage
 */
const getAuthToken = () => {
  return localStorage.getItem('token');
};

/**
 * Enhanced fetch that automatically adds Authorization header
 */
export const fetchWithAuth = async (url, options = {}) => {
  const token = getAuthToken();
  
  const headers = {
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    // Identity invalidated or token expired
    localStorage.removeItem('token');
    window.location.href = '/login';
    throw new Error('Session expired. Please login again.');
  }

  return response;
};

/**
 * API utility to wrap fetch and handle global errors like 401 Unauthorized.
 */
const apiRequest = async (url, options = {}) => {
  const token = getAuthToken();
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
    console.debug('apiRequest: Adding Authorization header for', url);
  } else {
    console.warn('apiRequest: No token found for', url);
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  });

  console.debug(`apiRequest: ${url} returned ${response.status}`);

  if (response.status === 401) {
    // Identity invalidated or token expired
    console.warn('apiRequest: 401 Unauthorized, clearing token and redirecting to login');
    localStorage.removeItem('token');
    window.location.href = '/login';
    throw new Error('Session expired. Please login again.');
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP Error: ${response.status}`);
  }

  return response.json();
};

export const ProductService = {
  createProduct: async (data) => {
    const res = await apiRequest('/api/products/save', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return { data: res };
  },
  // ... other methods would be updated similarly
};

export default apiRequest;
